// Typelizer digest f8117f7e5057091c445dbe5c227bdb59
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/payments/:payment_id/credit_notes */
  create: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/credit_notes', params, options),
    method: 'post',
  }),
}
